import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { renderStyledElementStyles } from '../../helpers';
import {
  CallToActionConfigProps,
  ImageTagConfigProps,
  SiteBuilderModule,
} from '../sharedComponents';
import { ZoomableImageDefault } from './displayStyles';
import { connect } from 'react-redux';

const Wrapper = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.siteBuilderModules.zoomableImageModule,
    )}
  ${({ theme }) => renderStyledElementStyles(theme, theme.module.vStyles)}
`;

const ZoomableImageModule = (props) => {
  const { pageConfig: { tenantId } = {}, section } = props;
  const {
    title,
    titleSize,
    text,
    alt,
    image: { path },
    link: ctaConfig = {},
    style: visualStyle,
    type,
  } = section;
  const themeConfig = useContext(ThemeContext);
  const { zoomableImageModule } = themeConfig.siteBuilderModules;
  const vStyles = zoomableImageModule.visualStyles[visualStyle];
  const dStyles = zoomableImageModule.displayStyles.DEFAULT;

  return (
    <SiteBuilderModule section={section} moduleTheme={{ dStyles, vStyles }}>
      <Wrapper data-testid="zoomable-image-wrapper">
        <ZoomableImageDefault
          title={title}
          titleSize={titleSize}
          text={text}
          alt={alt}
          ctaConfig={ctaConfig}
          path={path}
          tenantId={tenantId}
          moduleType={type}
        />
      </Wrapper>
    </SiteBuilderModule>
  );
};

ZoomableImageModule.propTypes = {
  section: PropTypes.shape({
    title: PropTypes.string,
    titleSize: PropTypes.string,
    text: PropTypes.string,
    image: ImageTagConfigProps.isRequired,
    link: CallToActionConfigProps,
    style: PropTypes.oneOf(['PRIMARY', 'SECONDARY', 'WHITE']).isRequired,
  }).isRequired,
  pageConfig: PropTypes.shape({
    tenantId: PropTypes.string,
  }),
};

const mapStateToProps = (state) => ({
  pageConfig: state.pageConfig,
});

export default connect(mapStateToProps)(ZoomableImageModule);
